module.exports = __webpack_public_path__ + "img/4.46d2ab46.jpg";